import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import styles from './styles.module.sass';

export default function Spinner() {
  return <div className={styles.box}><CircularProgress  style={{margin: '0 0 0 20px'}} size={50} thickness={7}  /></div>
}


// WEBPACK FOOTER //
// ./src/components/common/Spinner/Spinner.jsx